import React from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";

const ContentWrapper = (props) => {
  const { children } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        padding: isMobile ? "16px" : "32px",
      }}
    >
      {/* page content */}
      <Grid
        container
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 64px)",
          maxWidth: theme.breakpoints.values.lg,
          justifyContent: "center",
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default ContentWrapper;
